import React from 'react';
import { Button } from '../../globalStyles';
import { GiCrystalBars } from 'react-icons/gi';
import { GiCutDiamond, GiRock} from 'react-icons/gi';
import { IconContext } from 'react-icons/lib';
import { 
    PricingSection, 
    PricingWrapper, 
    PricingHeading, 
    PricingContainer, 
    PricingCard, 
    PricingCardInfo, 
    PricingCardIcon, 
    PricingCardPlan, 
    PricingCardCost, 
    PricingCardLength, 
    PricingCardFeatures, 
    PricingCardFeature} from './Pricing.elements';

const Pricing = () => {
    return (
        <IconContext.Provider value={{ color: '#a9b3c1', size: 64 }}>
            <PricingSection>
                <PricingWrapper>
                    <PricingHeading>Our Packages</PricingHeading>
                    <PricingContainer>
                        <PricingCard to="/form">
                            <PricingCardInfo>
                                <PricingCardIcon>
                                    <GiRock />
                                </PricingCardIcon>
                                <PricingCardPlan>Starting Package</PricingCardPlan>
                                <PricingCardCost>R 1200.00</PricingCardCost>
                                <PricingCardLength>Once-Off</PricingCardLength>
                                <PricingCardFeatures>
                                    <PricingCardFeature>Normal Basic Website</PricingCardFeature>
                                    <PricingCardFeature>One to four pages</PricingCardFeature>
                                    <PricingCardFeature>Full responsive design</PricingCardFeature>
                                </PricingCardFeatures>
                                <Button primary>Choose Plan</Button>
                            </PricingCardInfo>
                        </PricingCard>
                        <PricingCard to="/form">
                            <PricingCardInfo>
                                <PricingCardIcon>
                                    <GiCrystalBars />
                                </PricingCardIcon>
                                <PricingCardPlan>Medium Package</PricingCardPlan>
                                <PricingCardCost>R 1500.00</PricingCardCost>
                                <PricingCardLength>Once-Off</PricingCardLength>
                                <PricingCardFeatures>
                                    <PricingCardFeature>Great user experience</PricingCardFeature>
                                    <PricingCardFeature>One to six pages</PricingCardFeature>
                                    <PricingCardFeature>Everything required</PricingCardFeature>
                                </PricingCardFeatures>
                                <Button primary>Choose Plan</Button>
                            </PricingCardInfo>
                        </PricingCard>
                        <PricingCard to='/form'>
                            <PricingCardInfo>
                                <PricingCardIcon>
                                   <GiCutDiamond />
                                </PricingCardIcon>
                                <PricingCardPlan>Highest Package</PricingCardPlan>
                                <PricingCardCost>R 2000.00</PricingCardCost>
                                <PricingCardLength>Once-Off</PricingCardLength>
                                <PricingCardFeatures>
                                    <PricingCardFeature>One to ten pages</PricingCardFeature>
                                    <PricingCardFeature>Nice animations</PricingCardFeature>
                                    <PricingCardFeature>Everything required</PricingCardFeature>
                                </PricingCardFeatures>
                                <Button primary>Choose Plan</Button>
                            </PricingCardInfo>
                        </PricingCard>
                    </PricingContainer>
                </PricingWrapper>
            </PricingSection>
        </IconContext.Provider>
    )
}

export default Pricing;
